// The home page is composed entirely of admin-editable Visual Editor
// sections (same block editor used for blogs). Admins compose it via
// Admin → Site → Home page. On first visit, if no sections have been
// saved yet, we render the default homepage layout (Hero,
// Pathways, Recently added, Glossary teaser) — same look as the original
// hard-coded home — so the site never feels empty.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageSections from "@/components/PageSections";
import { defaultHomeSections } from "@/components/sectionTypes";

export default function Home() {
  const [sections, setSections] = useState(null);

  useEffect(() => {
    api.get("/site-settings/page-sections/home")
       .then(r => {
         const saved = r.data.sections || [];
         setSections(saved.length ? saved : defaultHomeSections());
       })
       .catch(() => setSections(defaultHomeSections()));
  }, []);

  if (sections === null) return <div className="p-12 text-slate-500">Loading…</div>;

  return (
    <div data-testid="home-page">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12">
        <PageSections sections={sections}/>
      </div>
    </div>
  );
}
